export const dismissAjaxError = () => (
  {
    type: 'DISMISS_AJAX_ERROR'
  }
)